import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPrinter, PrintService } from '@shared/services/print.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-delete-printer',
	templateUrl: './delete-printer.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeletePrinterComponent implements OnDestroy {
	@Output() deleted: EventEmitter<object> = new EventEmitter();
	private destroy$: Subject<void> = new Subject<void>();
	httpError: string = '';
	loading: boolean | null = null;

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public printer: IPrinter,
		public dialogRef: MatDialogRef<DeletePrinterComponent>,
		private printService: PrintService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';
		this.printService
			.deletePrinter(this.printer)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (deleteResponse) => {
					this.deleted.emit(deleteResponse);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
	}
}
